import { useState, useEffect } from 'react'
import { apiFetch } from '../utils/api'

const BASE_URL = import.meta.env.VITE_API_URL || 'http://92.53.107.15'

const C = {
  bg:        '#05050d',
  surface:   'rgba(255,255,255,0.028)',
  surface2:  'rgba(255,255,255,0.04)',
  border:    'rgba(180,185,230,0.09)',
  borderHi:  'rgba(180,185,230,0.2)',
  accent:    '#b8bdd4',
  accentDim: 'rgba(180,185,230,0.12)',
  text:      '#dce0f0',
  textMuted: '#8890aa',
  silverHi:  '#dce0f0',
  silverLo:  '#8890aa',
  green:     '#4dc88a',
  orange:    '#e09858',
  red:       '#d45a5a',
  purple:    '#9b7fd4',
  yellow:    '#e0b84a',
  greenDim:  'rgba(77,200,138,0.12)',
  redDim:    'rgba(212,90,90,0.12)',
}
const font = {
  heading: "'Cormorant Garamond', serif",
  mono:    "'Space Mono', monospace",
  body:    "'Inter', sans-serif",
}

export default function BotPrompt({ userId = 'user', initialPrompt }) {
  const [prompt, setPrompt] = useState(initialPrompt || '')
  const [loading, setLoading] = useState(false)
  const [saved, setSaved] = useState(false)
  const [msg, setMsg] = useState(null)

  useEffect(() => {
    if (initialPrompt) setPrompt(initialPrompt)
  }, [initialPrompt])

  async function generate() {
    setLoading(true)
    setMsg(null)
    try {
      const res = await apiFetch('/api/bot/generate-prompt', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: userId }),
      })
      const data = await res.json()
      if (data.error) throw new Error(data.error)
      setPrompt(data.prompt)
      setSaved(true)
      setMsg('Промпт сгенерирован и сохранён')
    } catch (e) {
      setMsg(`Ошибка: ${e.message}`)
    } finally {
      setLoading(false)
    }
  }

  async function save() {
    setLoading(true)
    try {
      const res = await apiFetch('/api/bot/save-prompt', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: userId, prompt }),
      })
      const data = await res.json()
      if (data.error) throw new Error(data.error)
      setSaved(true)
      setMsg('Сохранено')
      setTimeout(() => setMsg(null), 2000)
    } catch (e) {
      setMsg(`Ошибка: ${e.message}`)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{
      background: C.surface, border: `1px solid ${C.border}`,
      borderRadius: 12, padding: 20, marginTop: 16,
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
        <h3 style={{ margin: 0, fontFamily: font.heading, fontSize: 18, color: C.accent }}>
          Системный промпт бота
        </h3>
        <div style={{ display: 'flex', gap: 8 }}>
          {prompt && (
            <button
              onClick={save}
              disabled={loading || saved}
              style={{
                padding: '5px 14px', borderRadius: 6, cursor: loading ? 'default' : 'pointer',
                fontFamily: font.body, fontSize: 12,
                background: saved ? 'rgba(76,175,130,0.15)' : C.accentDim,
                border: `1px solid ${saved ? C.green : C.accent}`,
                color: saved ? C.green : C.accent,
              }}
            >
              {saved ? '✓ Сохранено' : 'Сохранить'}
            </button>
          )}
          <button
            onClick={generate}
            disabled={loading}
            style={{
              padding: '5px 14px', borderRadius: 6,
              cursor: loading ? 'default' : 'pointer',
              fontFamily: font.body, fontSize: 12,
              background: C.accentDim, border: `1px solid ${C.accent}`,
              color: C.accent,
            }}
          >
            {loading ? 'Генерирую...' : prompt ? 'Пересобрать' : 'Сгенерировать'}
          </button>
        </div>
      </div>

      {msg && (
        <div style={{ marginBottom: 10, fontSize: 12, color: C.green, fontFamily: font.body }}>
          {msg}
        </div>
      )}

      {prompt ? (
        <textarea
          value={prompt}
          onChange={e => { setPrompt(e.target.value); setSaved(false) }}
          rows={12}
          style={{
            width: '100%', boxSizing: 'border-box',
            background: C.bg, border: `1px solid ${C.border}`,
            borderRadius: 8, padding: '10px 14px',
            color: C.text, fontFamily: font.body, fontSize: 13,
            lineHeight: 1.6, resize: 'vertical', outline: 'none',
          }}
        />
      ) : (
        <div style={{
          padding: '20px', textAlign: 'center',
          color: C.textMuted, fontFamily: font.body, fontSize: 13,
          border: `1px dashed ${C.border}`, borderRadius: 8,
        }}>
          Промпт не сгенерирован. Нажми «Сгенерировать» — Claude создаст его на основе твоего профиля.
          <br />
          <span style={{ fontSize: 11, marginTop: 6, display: 'block' }}>
            Для лучшего результата сначала загрузи данные через анализ.
          </span>
        </div>
      )}
    </div>
  )
}
